import React from "react";
import { EmptyStateBody, EmptyStateIcon, EmptyStateTitle, EmptyStateWrap } from "../styles";
import { LABELS } from "../labels";

interface Props {
	title?: string;
	body?: string;
}

export default function EmptyState({ title = LABELS.emptyStateTitle, body = LABELS.emptyStateBody }: Props) {
	return (
		<EmptyStateWrap>
			<EmptyStateIcon>
				<i className="fa fa-file-text-o" />
			</EmptyStateIcon>
			<EmptyStateTitle>{title}</EmptyStateTitle>
			<EmptyStateBody>{body}</EmptyStateBody>
		</EmptyStateWrap>
	);
}
